/**
 * Under the drop list (user, 19/10/2026: "in the drop slots a button to
 * generate 10 slots", "update the number of best from here"): for each group
 * on all lists, the "Give each list its own drop" card with its "best N"
 * field — the same card as on the group's card.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';

import { useListGroupResolve } from '@/features/list-groups';

import { GroupChip } from '../../../../shared/GroupChip';
import { listChoiceOf } from '../../../groups/lists-per-day/list-choice';
import { RankSlotsCard } from '../../../groups/lists-per-day/RankSlotsCard';
import type { ContainerEditor } from '../../../state/useContainerEditor';
import type { GroupRef } from '../../hooks/use-general-times';

const GroupRankSlots: FC<{ group: GroupRef; editor: ContainerEditor }> = ({ group, editor }) => {
  const resolved = useListGroupResolve(group.id);
  const link = editor.draft.groups.find((g) => g.listGroupId === group.id);
  if (!link) return null;
  const chip = <GroupChip name={group.name} color={group.color} />;
  return <RankSlotsCard link={link} groupName={group.name} editor={editor} listCount={resolved.data ? resolved.data.lists.length : null} withLimit chip={chip} />;
};

export const DropRankSlots: FC<{ groupRefs: GroupRef[]; editor: ContainerEditor }> = ({ groupRefs, editor }) => {
  const all = groupRefs.filter((g) => listChoiceOf(g.listsPerDay) === 'all');
  if (!all.length) return null;
  return (
    <div className="flex flex-col gap-2">
      {all.map((g) => (
        <GroupRankSlots key={g.id} group={g} editor={editor} />
      ))}
    </div>
  );
};
